import { useEffect, useRef, useState } from 'react';
import { ChatMessage } from './chat-message';
import { Avatar, AvatarFallback } from '@/components/shadcn-ui/avatar';
import AcknowledgmentModal from '../AcknowledgmentModal';

export function ChatList({ messages, isLoading, streamingMessage, protectedRoute, showAcknowledgmentModal, AcknowledgmentModalContent }) {
  const scrollRef = useRef(null);
  const bottomRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(true);

  useEffect(() => {
    if (!scrollRef.current) return;
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isLoading, streamingMessage]);

  return (
    <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 space-y-4 no-scrollbar">
      {messages.length === 0 ? (
        <div className="flex items-center justify-center h-full text-gray-400">Start a conversation</div>
      ) : (
        messages.map(message => <ChatMessage key={message.id} message={message} protectedRoute={protectedRoute} />)
      )}

      {streamingMessage && (
        <div className="flex gap-3 flex-row">
          <Avatar className="size-10 bg-black">
            <AvatarFallback>
              <img src="/kelly.png" alt="Kelly Avatar" className="size-10 object-cover bg-black" />
            </AvatarFallback>
          </Avatar>
          <div className="rounded-lg p-3 max-w-[80%] text-white bg-neutral-800">
            <p className="text-sm whitespace-pre-wrap inline-flex items-center">
              <span>{streamingMessage}</span>
              {/* <span className="inline-block w-0.5 h-4 bg-white ml-1 animate-pulse"></span> */}
            </p>
          </div>
        </div>
      )}

      {showAcknowledgmentModal && (
        <AcknowledgmentModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSubmit={() => {
            console.log("All items acknowledged");
          }}
          items={AcknowledgmentModalContent}
        />
      )}

      {isLoading && !streamingMessage && (
        <div className="flex items-center gap-2 text-gray-400">
          <div className="animate-pulse">Thinking...</div>
        </div>
      )}

      <div ref={bottomRef} />
    </div>
  );
}
